import React, { useContext, useEffect } from 'react'

import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { CSSRulePlugin } from 'gsap/CSSRulePlugin'

import Footer from '../components/molecules/footer'
import Navbar from '../components/molecules/nav'
import Menu from '../components/organisms/menu'
import { NavContext } from '../contexts/nav-context'

interface Props {
	children: React.ReactNode
}

const Layout: React.FC<Props> = (props: Props) => {
	useEffect(() => {
		gsap.registerPlugin(ScrollTrigger, CSSRulePlugin)
	}, [])

	const { toggleNavMenu } = useContext(NavContext)

	return (
		<div className='layout'>
			<Navbar onClickNavIcon={toggleNavMenu} />
			<Menu />
			<main>{props.children}</main>
			<Footer />
		</div>
	)
}

export default Layout
